module.exports = __webpack_public_path__ + "static/img/收获-001.fa7b537.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/support/收获-001.png
// module id = zFlM
// module chunks = 0